import React from "react";
import getRoutes from "../const/routes";
import { Route, Routes } from "react-router-dom";
import Page404 from "../pages/Page404";

const RenderRoutes = () => {
  return (
    <Routes>
      {getRoutes().map(
        ({ path, component }) =>
          path &&
          component && (
            <Route
              key={path}
              path={path}
              element={React.createElement(component)}
            />
          )
      )}
      <Route path={`*`} element={<Page404 />} />
    </Routes>
  );
};

export default RenderRoutes;
